import { useCallback } from "react"
import {
  getAccessesForResource,
  useRegistrationAccesses
} from "../../registration/access"

/**
 * Returns a predicate that is true only when the registration-access store is
 * ready and the resource has at least one resumable access row. Loading,
 * signed-out, and error states never imply access.
 */
export function useHasLibraryResourceAccess() {
  const { index, ready, error } = useRegistrationAccesses()

  return useCallback(
    (resourceId: number) => {
      if (!ready || error) return false
      return (
        getAccessesForResource(index, resourceId, { resumableOnly: true })
          .length > 0
      )
    },
    [index, ready, error]
  )
}
